const REEPAY_SCRIPT_ID = 'reepay-checkout-sdk'
const REEPAY_SCRIPT_URL = 'https://checkout.reepay.com/checkout.js'

let reepaySdkPromise = null

export function loadReepaySdk () {
    if (typeof window === 'undefined') {
        return Promise.reject(new Error('Reepay checkout is only available in the browser'))
    }

    if (window.Reepay) {
        return Promise.resolve(window.Reepay)
    }

    if (reepaySdkPromise) {
        return reepaySdkPromise
    }

    reepaySdkPromise = new Promise((resolve, reject) => {
        const script = document.getElementById(REEPAY_SCRIPT_ID) || document.createElement('script')

        script.id = REEPAY_SCRIPT_ID
        script.src = REEPAY_SCRIPT_URL
        script.async = true
        script.addEventListener('load', () => {
            if (window.Reepay) {
                resolve(window.Reepay)
                return
            }

            script.remove()
            reject(new Error('Reepay checkout loaded without exposing its SDK'))
        }, { once: true })
        script.addEventListener('error', () => {
            script.remove()
            reject(new Error('Failed to load Reepay checkout'))
        }, { once: true })

        if (!script.isConnected) {
            document.head.appendChild(script)
        }
    }).catch(error => {
        reepaySdkPromise = null
        throw error
    })

    return reepaySdkPromise
}